export default ({ app, $auth }) => {
  $auth.onRedirect((to, from) => {
    const _to = from.indexOf('/subscribe/') > -1 ? from : to
    return app.localePath(_to)
  })
}
